import React from "react";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  GridToolbarExport,
} from "@mui/x-data-grid";
import "./customTable.css";

const CustomTable = (props) => {
  const classes = {
    columnHeader: "data-grid-header",
  };

  function CustomToolbar(props) {
    return (
      <GridToolbarContainer {...props}>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
        <GridToolbarExport />
      </GridToolbarContainer>
    );
  }

  return (
    <div
      style={{
        height: props.height ? props.height : 500,
        width: props.width ? props.width : "100%",
      }}
    >
      <DataGrid
        rows={props.rows}
        rowHeight={props.rowHeight}
        columns={props.columns}
        pageSize={props.pageSize}
        rowsPerPageOptions={props.rowsPerPageOptions}
        disableSelectionOnClick
        components={{ Toolbar: CustomToolbar }}
        getRowHeight={() => "auto"}
        classes={classes}
      />
    </div>
  );
};

export default CustomTable;
